import styled, { ThemedStyledProps } from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div<{ first?: boolean; last?: boolean }>`
  font-size: 18px;
  font-weight: bold;
  text-transform: capitalize;

  ${media.lessThan('companyHistory')`
    text-align: center;
    margin: 0 auto 10px;
  `} ${media.moreThan('companyHistoryPlus')`
    position: absolute;
    top: 19px;
    right: calc(100% + 25px);
    padding: 20px;
    background: white;

    ${(props: ThemedStyledProps<unknown, unknown>) =>
      (props as ThemedStyledProps<{ first?: boolean }, unknown>).first
        ? 'top: 29px; padding-top: 10px;'
        : ''}
    ${(props: ThemedStyledProps<unknown, unknown>) =>
      (props as ThemedStyledProps<{ last?: boolean }, unknown>).last
        ? 'height: 100%;'
        : ''}
  `};
`;
